export default {
  /// <summary>
  /// File tạm
  /// </summary>
  Temp: 0,
};
